const asyncPostRoutes = {
  path: 'post/list',
  component: () => import('@/views/system/post/index'),
  funcPerms: 'system:setting:post',
  name: 'auth-post',
  meta: {
    title: '职位管理',
    // icon: 'el-icon-user',
    icon: 'index',
    affix: false,
    noCache: true
  }
}

export default asyncPostRoutes
